import React, { createContext, useState, useEffect, useCallback } from 'react';

export const ThemeContext = createContext();

const STORAGE_KEY = 'bridge-theme';

const currentUserKey = () => {
    try {
        const email = (localStorage.getItem('userEmail') || '').trim().toLowerCase();
        return email ? `${STORAGE_KEY}:${email}` : '';
    } catch (error) {
        return '';
    }
};

export const readStoredTheme = () => {
    try {
        const userKey = currentUserKey();
        const saved = (userKey && localStorage.getItem(userKey))
            || localStorage.getItem(STORAGE_KEY)
            || localStorage.getItem('theme');
        return saved === 'dark' ? 'dark' : 'light';
    } catch (error) {
        return 'light';
    }
};

export const applyTheme = (theme) => {
    const next = theme === 'dark' ? 'dark' : 'light';
    document.documentElement.setAttribute('data-theme', next);
    try {
        localStorage.setItem(STORAGE_KEY, next);
        const userKey = currentUserKey();
        if (userKey) localStorage.setItem(userKey, next);
    } catch (error) {
        /* private mode or blocked storage — the choice still applies this session */
    }
    return next;
};

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(readStoredTheme);

    useEffect(() => {
        applyTheme(theme);
    }, [theme]);

    useEffect(() => {
        const restore = () => setTheme(readStoredTheme());
        window.addEventListener('pageshow', restore);
        window.addEventListener('focus', restore);
        return () => {
            window.removeEventListener('pageshow', restore);
            window.removeEventListener('focus', restore);
        };
    }, []);

    const setThemeMode = useCallback((next) => {
        setTheme(applyTheme(next));
    }, []);

    return (
        <ThemeContext.Provider value={{ theme, setThemeMode }}>
            {children}
        </ThemeContext.Provider>
    );
};
